import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { typeIcons } from './_common/notificationTypes'

const LatestNotificationItem = (props) => {
  const { group, type, title } = props
  const theme = useTheme()
  const navigate = useNavigate()

  const iconWidth = 60

  const iconStyle = {
    width: `${iconWidth}px`,
    height: `${iconWidth}px`,
    borderRadius: `${iconWidth / 2}px`,
    background: theme.palette.violetsAreBlue,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const notificationTitleStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
  }

  const handleClick = () => {
    navigate('/notifications', { state: { group } })
  }

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      onClick={handleClick}
      sx={{
        width: '100%',
        padding: '10px 0px',
        borderBottom: `${theme.palette.grayX11} 1px solid`,
        cursor: 'pointer',
      }}
    >
      <Box sx={iconStyle}>
        { typeIcons[type] ? typeIcons[type] : '' }
      </Box>
      <Box sx={{ width: `calc(100% - ${iconWidth + 20}px)` }}>
        <Box sx={notificationTitleStyle}>{title}</Box>
      </Box>
    </Stack>
  )
}

export default LatestNotificationItem